import { render, staticRenderFns } from "./Introduce.vue?vue&type=template&id=66e51102&scoped=true&"
import script from "./Introduce.vue?vue&type=script&lang=js&"
export * from "./Introduce.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/introduce.css?vue&type=style&index=0&id=66e51102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e51102",
  null
  
)

export default component.exports